import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import _ from 'lodash'

@Injectable({
  providedIn: 'root'
})
export class PageTrackerService {
  private apiBaseUrl = '/data/user/pageview'; 

  constructor(
    @Inject(HttpClient) private http: HttpClient,
    @Inject('ApiBase') private apiBase:any,
  ) {

  }

  // AngularJS needs headers to be a function to access header values
  private headersFunctionWrapper(headers: HttpHeaders): (name: string) => string | null {
    return (name: string) => headers.get(name);
  }
  
  trackPageView(personKey: string, herdKey: string, pageName: string,callBack:Function = () => {}): void {
   
    const url = this.apiBase.prepareUrl(this.apiBaseUrl);
    const reqBody = { personKey, herdKey, pageName };
    const sendHeaders = _.get(this.apiBase.sendHeaders(), "headers", {});
    const headers = new HttpHeaders(sendHeaders);

    this.http.post(url, reqBody, { headers, observe: 'response' }).subscribe({
        next: (response:any) => {
           this.apiBase.processHeaders(this.headersFunctionWrapper(response.headers));
           const data = this.apiBase.lowerCaseObjectKeys(response.body);
           this.apiBase.callbackOrLog(callBack, null, data || null)
        },
        error: (error:any) => {
            const data = {
                statusCode: error.status,
                statusText: error.statusText
            };
            this.apiBase.callbackOrLog(callBack, error.data || 'unspecified', data);
        }
    });

  }
}